import React from 'react';

export const CreateServiceHistory = React.lazy(
  () => import('./CreateServiceHistory/CreateServiceHistory')
);
